import { createMutableAction } from '@bimser/core';
import { SET_DELEGATION_INFORMATION } from './actionTypes';
export const setDelegationInformationAction = (data: any) =>
	createMutableAction(SET_DELEGATION_INFORMATION, data);
